import $ from 'jquery';

export class Component {
    constructor() {
        this.$elements = [];

        /**
         * Selector to look for on the page.
         * Intended to be overwritten by child class.
         * @type {string}
         */
        this.selector = '';

        /**
         * Set to true in subclass to disable selecting elements.
         * Init will be called as soon as the Component is instantiated
         * @type {boolean}
         */
        this.skipSetup = false;
    }

    /**
     *  Lifecycle method that runs if any elements are found.
     *  Intended to be overwritten by child class.
     */
    init() { }

    static create() {
        const instance = new this();
        // eslint-disable-next-line no-underscore-dangle
        instance._start();
        return instance;
    }

    /**
     * @private
     */
    /* eslint-disable no-underscore-dangle */
    _start() {
        if (this.skipSetup) {
            this.init();
            return;
        }

        if (this.selector === '') {
            throw new Error('No selector provided');
        }

        this.$elements = $(this.selector);

        if (!this.$elements.length) return;

        this.init();
    }
}



// WEBPACK FOOTER //
// ./assets/js/core/component.js